// Schema for Photo Booths vendor-type-specific fields.

import { RENTAL_TIME_MIN_OPTIONS, RENTAL_TIME_MAX_OPTIONS, PHOTO_BOOTH_SERVICE_OPTIONS, PHOTO_BOOTH_MODES } from '../constants/vendorOptions';

// Full chronological order for validating rental time — MIN_OPTIONS already
// covers 'No Min' through '7 Hours' in order; MAX_OPTIONS' remaining entries
// ('8 Hours' through 'No Max') are appended to complete the sequence.
const RENTAL_TIME_ORDER = [...RENTAL_TIME_MIN_OPTIONS, ...RENTAL_TIME_MAX_OPTIONS.slice(7)];

export const photoBoothsSchema = {
  vendorType: 'Photo Booths',
  fields: [
    {
      type: 'row',
      fields: [
        { key: 'photoBoothBasePrice', type: 'price', label: 'Starting Price', optional: true },
        { key: 'photoBoothAvgPrice', type: 'price', label: 'Average Price', optional: true },
      ],
    },
    {
      type: 'row',
      fields: [
        { key: 'photoBoothMinRental', type: 'select', label: 'Min Rental Time', options: RENTAL_TIME_MIN_OPTIONS, optional: true },
        { key: 'photoBoothMaxRental', type: 'select', label: 'Max Rental Time', options: RENTAL_TIME_MAX_OPTIONS, optional: true },
      ],
    },
    { key: 'photoBoothServiceOptions', type: 'chips', label: 'Service Options', options: PHOTO_BOOTH_SERVICE_OPTIONS, optional: true },
    { key: 'photoBoothModes', type: 'chips', label: 'Modes Available', displayLabel: 'Modes', options: PHOTO_BOOTH_MODES, optional: true },
  ],
  priceValidations: [
    { startingKey: 'photoBoothBasePrice', avgKey: 'photoBoothAvgPrice' },
  ],
  selectRangeValidations: [
    { minKey: 'photoBoothMinRental', maxKey: 'photoBoothMaxRental', orderedOptions: RENTAL_TIME_ORDER },
  ],
};